import { baseURL } from "../Config";
import axios from "axios";
import { toast } from "react-toastify";
import { trimData } from "../utilities/TrimPayloadData";

export const handlePostRequest = async (data, url, showToast = true) => {
  if (!navigator.onLine) {
    if (showToast)
      toast.error(
        "No internet connection. Please check your network and try again."
      );
    return;
  }

  const id = showToast ? toast.loading("Please wait...") : null;
  data = await trimData(data);

  try {
    const response = await axios({
      method: "post",
      url: `${baseURL + url}`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    });

    if (showToast) {
      toast.update(id, {
        render: response.data.messages || "Request successful!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    }

    return response?.data;
  } catch (error) {
    if (error?.response?.data?.message === "Session Expired") {
      localStorage.clear();
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    }

    if (showToast) {
      if (error?.response?.status === 500) {
        toast.update(id, {
          render: error?.response?.data?.messages || "Something went wrong !!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } else if (error?.response?.status === 400) {
        toast.update(id, {
          render:
            error?.response?.data?.[0]?.toastError ||
            error?.response?.data?.messages ||
            "Something went wrong !!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toast.update(id, {
          render: error?.response?.data?.messages || "Something went wrong !!",
          type: "warn",
          isLoading: false,
          autoClose: 3000,
        });
      }
    }
    throw error;
  }
  //  finally {
  //     if (id && showToast) toast.dismiss(id);
  // }
};
